export default function (context) {
    if (context === document) {
        let manifest = {
            "gcm_sender_id": "1096823467123",
            "gcm_user_visible_only": true,

            "short_name": "Coing",
            "name": "Coing",
            "start_url": "/",
            "background_color": "#ffffff",
            "theme_color": "#0279bb",
            "display": "standalone",
            "splash_pages": null,
        };
        let url = new URL(window.location.origin + window.location.pathname);
        url.setPath = function (path) {
            this.pathname = path;
            return this;
        };

        const setCommunity = function (community) {
            manifest.short_name = community.title || community.name;
            manifest.name = community.title || community.name;
            manifest.start_url = window.location.origin + window.location.pathname;
            if (community.icons && community.icons.length > 0) {
                manifest.icons = community.icons.map(val => ({
                    src: val.file,
                    type: "image/" + val.type,
                    sizes: val.size + 'x' + val.size
                }));
            } else {
                manifest.icons = [
                    {
                        "src": url.setPath("/static-icons/with-192.png").href,
                        "type": "image/png",
                        "sizes": "192x192"
                    },
                    {
                        "src": url.setPath("/static-icons/with-512.png").href,
                        "type": "image/png",
                        "sizes": "512x512"
                    }
                ];
            }
        };

        if (typeof community !== 'undefined' && community) {
            setCommunity(community);
        } else if (typeof group !== 'undefined' && group) {
            setCommunity(group.community);
        } else {
            manifest.start_url = window.location.origin;
            manifest.icons = [
                {
                    "src": url.setPath("/static-icons/with-192.png").href,
                    "type": "image/png",
                    "sizes": "192x192"
                },
                {
                    "src": url.setPath("/static-icons/with-512.png").href,
                    "type": "image/png",
                    "sizes": "512x512"
                }
            ];
        }
        const stringManifest = JSON.stringify(manifest);
        const blob = new Blob([stringManifest], {type: 'application/json'});
        const manifestURL = URL.createObjectURL(blob);
        $('#manifest-link').attr('href', manifestURL);
    }
}
